import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  const firstExtraIndex = packageIncludes.findIndex(item => item.kind === 'extra');
  return <section id="pricing" className="py-20 px-4 bg-[#F8F3EC] relative" data-id="element-217" data-mp="1s7sl0hgc5sx2">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-218" data-mp="1x9rpxvrq4xw4">
        <div className="text-center mb-10" data-id="element-219" data-mp="227t5w7tush3d">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-[#520128] uppercase" data-id="element-220" data-mp="226i42djyxjew">
            Your Complete <span className="text-[#8E2C5C]" data-id="element-221" data-mp="2wa1m6jhvx01">Sewing &amp; Pattern Making Instructor Atlas</span> Package
          </h2>
          <p className="text-slate-700/80 text-sm md:text-base" data-id="element-222" data-mp="7vwegevevb8b">
            Everything You Need to Plan, Explain, Demonstrate &amp; Assess Your Students More Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#EBDCC8] border-2 border-[#520128] rounded-3xl p-1 relative shadow-xl shadow-[#520128]/10" data-id="element-223" data-mp="1hnvckutoofby">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#C9A24A] text-[#3A001D] font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-224" data-mp="20fxwqg5jadqy">
            <Sparkles size={14} data-id="element-225" data-mp="1rezo1kk5hi21" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-226" data-mp="k1xzxe1zj47x">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-227" data-mp="jzuzs174buph" />

            <p className="text-sm font-bold tracking-widest text-[#8A6A2B] mb-3" data-id="element-228" data-mp="hforxifdvk3n">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-[#F8F3EC] border border-[#E6D5BF] rounded-xl p-4" data-id="element-229" data-mp="meryj7b0hydq">
              <li className="text-xs font-bold tracking-widest text-[#8A6A2B]" data-id="element-230" data-mp="cievvjxhoa6u">
                THE COMPLETE 6-IN-1 VISUAL SEWING TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-231" data-mp="3i8jy2hfvi9s" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-[#8A6A2B]" data-id="element-232" data-mp="3kzjelu5malcw">
                      PLUS 5 EXCLUSIVE BONUSES
                    </li>}
                  {itemIndex === firstExtraIndex && <li className="pt-2 border-t border-[#E6D5BF]" aria-hidden="true" data-id="element-233" data-mp="3bzwpa6q5x607" />}
                  <li className={`flex items-start gap-2 text-sm ${item.kind === 'extra' ? 'font-bold uppercase tracking-wide text-[#520128]' : 'text-slate-700'}`} data-id="element-234" data-mp="3g186poyvukxb">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-[#8E2C5C] shrink-0 mt-0.5" data-id="element-235" data-mp="31cf437ek3crp" /> : <Check size={16} className="text-[#8E2C5C] shrink-0 mt-0.5" data-id="element-236" data-mp="3g8xmbcl2qx0b" />}
                    <span data-id="element-237" data-mp="3ba34acuxlch9">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-238" data-mp="3p4dhpy1h9k80">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-239" data-mp="3l05uk5ao4cbw">
                <span className="text-2xl md:text-3xl text-[#520128] font-semibold" data-id="element-240" data-mp="2v2mqctbhm7s">YOUR PRICE:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#8E2C5C]" data-id="element-241" data-mp="3u1m3s9pqy8ej">
                  {PRICE_LABEL}
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-242" data-mp="lzo6358vdhkh">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-243" data-mp="vofuj3eq1jqn">
              <span className="flex items-center gap-1.5" data-id="element-244" data-mp="3v5nvlvyvnwb5">
                <Lock size={12} className="text-[#8E2C5C]" data-id="element-245" data-mp="30to7ne40103" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-246" data-mp="7zwner7erd05">
                <Zap size={12} className="text-[#8E2C5C]" data-id="element-247" data-mp="7ybsv1l3fu2a" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-248" data-mp="d0klfwu20u3v">
                <Wallet size={12} className="text-[#8E2C5C]" data-id="element-249" data-mp="1jflarjokqe1h" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}